import request from '@/utils/request'

//添加基地
export function addTrainBase(data) {
    return request({
        url: '/api/TrainInfo/Add',
        method: 'post',
        data
    })
}
//删除
export function delTrainBase(data) {
    return request({
        url: '/api/TrainInfo/Delete',
        method: 'post',
        data
    })
}

//查询
export function selTrainBase(params) {
    return request({
        url: '/api/TrainInfo/Load',
        method: 'get',
        params
    })
}
//id查询
export function selTrainBaseById(params) {
    return request({
        url: '/api/TrainInfo/Get',
        method: 'get',
        params
    })
}
//修改
export function updateTrainBase(data) {
    return request({
        url: '/api/TrainInfo/Update',
        method: 'post',
        data
    })
}

//获取基地列表
export function getBaseInfo(params) {
    return request({
        url: '/api/TrainInfo/GetBaseInfo',
        method: 'get',
        params
    })
}
//获取问卷列表
export function getPollInfo(params) {
    return request({
        url: '/api/TrainInfo/GetPollInfo',
        method: 'get',
        params
    })
}

//培训公布成绩
export function publicScore(params) {
    return request({
        url: '/api/TrainInfo/PublicScore',
        method: 'get',
        params
    })
}

//获取审核数据
export function getPassData(params) {
    return request({
        url: '/api/TrainInfo/PassData',
        method: 'get',
        params
    })
}
//获取审核统计数量
export function getPassTj(params) {
    return request({
        url: '/api/TrainInfo/PassTj',
        method: 'get',
        params
    })
}
//获取最近更新数据
export function getLateData(params) {
    return request({
        url: '/api/TrainInfo/LateData',
        method: 'get',
        params
    })
}

//获取最近更新数据
export function TrainInfoStatistical(params) {
    return request({
        url: '/api/TrainInfo/Statistical',
        method: 'get',
        params
    })
}
//免训列表
export function getLoad(params) {
    return request({
        url: '/api/TrainFree/Load',
        method: 'get',
        params
    })
}
//免训审核
export function getPass(params) {
    return request({
        url: '/api/TrainFree/Pass',
        method: 'get',
        params
    })
}
export function trainPass(params) {
    return request({
        url: '/api/TrainInfo/Pass',
        method: 'get',
        params
    })
}
//培训日程
export function getList(params) {
    return request({
        url: '/api/TrainSchedule/GetList',
        method: 'get',
        params
    })
}
//培训进度
export function getProcessJg(params) {
    return request({
        url: '/api/TrainInfo/ProcessJg',
        method: 'get',
        params
    })
}
//培训进度
export function learnPeoList(params) {
    return request({
        url: '/api/TrainInfo/LearnPeoList',
        method: 'get',
        params
    })
}
//培训班人员学习详细
export function learnPeoDetail(params) {
    return request({
        url: '/api/TrainInfo/LearnPeoDetail',
        method: 'get',
        params
    })
}

//添加基地
export function generateManua(para, data) {
    return request({
        url: `/resource/TrainInfo/GenerateManual?trainId=${para}`,
        method: 'post',
        data
    })
}
export function getSubject(params) {
    return request({
        url: '/api/TrainSubject/GetSubject',
        method: 'get',
        params
    })
}

export function addSubject(params, data) {
    return request({
        url: '/api/TrainSubject/AddSubject',
        method: 'post',
        params,
        data
    })
}



export function StatisticalView(params) {
    return request({
        url: '/api/TrainInfo/StatisticalView',
        method: 'get',
        params
    })
}


//获取考勤申诉列表
export function getAlarmFreeLoad(params) {
    return request({
        url: '/api/AlarmFree/Load',
        method: 'get',
        params
    })
}
//考勤申诉审核
export function setAlarmFreePass(params) {
    return request({
        url: '/api/AlarmFree/Pass',
        method: 'get',
        params
    })
}

//生成手册
export function downManualApi(params) {
    return request({
        url: '/resource/TrainSchedule/DownDoc',
        method: 'get',
        params
    })
}

//查询训历科目
export function getSubjectApi(params) {
    return request({
        url: '/api/Center/GetTrainScore',
        method: 'get',
        params
    })
}

//获取训历详情
export function getTrainingInfoApi(params) {
    return request({
        url: '/api/PmiUser/GetDetail',
        method: 'get',
        params
    })
}

//获取免训申请表详情
export function getExemptionTrainInfoApi(params) {
    return request({
        url: '/api/TrainFree/GetDetail',
        method: 'get',
        params
    })
}

//获取审核流程列表
export function getFlowApi(params) {
    return request({
        url: '/api/TrainFree/GetFlow',
        method: 'get',
        params
    })
}